import { Component, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { DataBindingDirective } from "@progress/kendo-angular-grid";
import { MessageService } from "@progress/kendo-angular-l10n";
import { CompositeFilterDescriptor, filterBy, process } from "@progress/kendo-data-query";
import { Employee } from "src/app/models/employee.model";
import { CustomMessagesService } from "src/app/services/custom-messages.service";
import { DialogCloseResult, DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { BaseHttpResponse, BaseHttpResult } from "src/app/models/base-http-response";
import { Site } from "src/app/models/site.model";
import { ApiService } from "src/app/services/http/api.service";
import { UsersFormComponent } from "../users-form/users-form.component";
import { NotificationService } from "@progress/kendo-angular-notification";
import { UsersImportFormComponent } from "../users-import-form/users-import-form.component";
import { User } from "src/app/global-functions";
import { ExcelExportData } from "@progress/kendo-angular-excel-export";

@Component({
  selector: "app-users-component",
  templateUrl: "./users.component.html",
})
export class UsersComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
  @ViewChild("container", { read: ViewContainerRef })
  public container: ViewContainerRef | undefined;
  public gridData: Employee[] = [];
  public gridView: any[] = [];
  public filter: CompositeFilterDescriptor | undefined;
  public mySelection: string[] = [];
  public customMsgService: CustomMessagesService;

  constructor( public msgService: MessageService, private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService ) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.allData = this.allData.bind(this);
  }

  public ngOnInit(): void {
    this.gridView = this.gridData;
    this.load();
  }

  public upload() {
    const dialogRef: DialogRef = this.dialogService.open({
      title: this.customMsgService.translate("importarUtilizadores"),
      content: UsersImportFormComponent,
    });

    dialogRef.result.subscribe((result) => {
      this.gridView = this.gridData;
      this.load();
    });
  }
  public onFilter(inputValue: string): void {
    this.gridView = process(this.gridData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: this.getField,
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    }).data;
    this.dataBinding ? (this.dataBinding.skip = 0) : null;
  }

  public getField = (args: Employee) => {
    var equpas = args.nomesEquipas?.join("_");
    return `${args.nome}_${args.idCartao}_${args.idFuncao}_${args.codigoDeFuncionario}_${args.telemovel}_${args.funcao}_${equpas}`;
  };

  public open(): void {
    const dialogRef: DialogRef = this.dialogService.open({
      title:
        this.customMsgService.translate("btnCriar") +
        " " +
        this.customMsgService.translate("user"),
      content: UsersFormComponent,
    });
    dialogRef.result.subscribe((result) => {
      this.gridView = this.gridData;
      this.api
        .getRequest<BaseHttpResponse<Employee[]>>("Utilizador/GetUtilizadores")
        .then((data) => {
          this.gridData = data.value;
          this.gridView = this.gridData;
        })
        .catch((err) => { });
    });
  }

  canList() {
    return User.canUserList();
  }

  canCreate() {
    return User.canUserCreate();
  }

  canEdit() {
    return User.canUserEdit();
  }

  canDelete() {
    return User.canUserDelete();
  }

  canUpload() {
    return User.canUserUpload();
  }

  public openEdit(c: Employee): void {
    const dialogRef: DialogRef = this.dialogService.open({
      title:
        this.customMsgService.translate("btnEditar") +
        " " +
        this.customMsgService.translate("user"),
      content: UsersFormComponent,
    });

    const userInfo = dialogRef.content.instance as UsersFormComponent;
    userInfo.formValue = c;
    userInfo.setFormValues();

    dialogRef.result.subscribe((result) => {
      this.gridView = this.gridData;
      this.api
        .getRequest<BaseHttpResponse<Employee[]>>("Utilizador/GetUtilizadores")
        .then((data) => {
          this.gridData = data.value;
          this.gridView = this.gridData;
        })
        .catch((err) => { });
    });

  }

  public delete(e: Site): void {
    var sim = this.customMsgService.translate("yes");
    var nao = this.customMsgService.translate("no");
    const dialog: DialogRef = this.dialogService.open({
      appendTo: this.container,
      title: this.customMsgService.translate("confirmacao"),
      content: this.customMsgService.translate("desejaRemover"),
      actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
      width: 450,
      height: 200,
      minWidth: 250,
    });
    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
      } else if (result.text == sim) {
        this.api
          .cruddelete<BaseHttpResult>("Utilizador", e.id)
          .then((res) => {
            if (res.ok) {
              this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate(
                  "registoApagadoComSucesso"
                ),
                animation: { type: "slide", duration: 500 },
                position: { horizontal: "center", vertical: "top" },
                type: { style: "success", icon: true },
                hideAfter: 2000,
              });

              this.load();
            } else {
              this.notificationService.show({
                appendTo: this.container,
                content: res.message,
                animation: { type: "slide", duration: 500 },
                position: { horizontal: "center", vertical: "top" },
                type: { style: "error", icon: true },
                hideAfter: 4000,
              });
            }
          })
          .catch((err) => {
          });
      }
    });
  }
  load() {
    this.api
      .getRequest<BaseHttpResponse<Employee[]>>("Utilizador/GetUtilizadores")
      .then((data) => {
        this.gridData = data.value;
        this.gridView = this.gridData;
      })
      .catch((err) => { });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.gridView, { filter: this.filter }).data,
    };

    return result;
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.gridData = filterBy(this.gridView, filter);
  }
}
